import { useAwardModalStore } from './useAwardModal';

export const useAwardContent = () => {
	const recipient = useAwardModalStore((state) => state.recipient);

	if (!recipient) {
		return null;
	}

	return {
		type: 'doc',
		content: [
			{
				type: 'paragraph',
				content: [
					{
						type: 'recipient',
						attrs: {
							id: recipient.username,
							record: {
								id: recipient.id,
								displayName: recipient.displayName,
								imageSrc: recipient.profilePic,
								username: recipient.username,
							},
						},
					},
					{
						type: 'text',
						text: ' ',
					},
				],
			},
		],
	};
};
